const RESOURCE_NAME = '';//'/auth/';
import axios from "@/api/http-common";
import config from "@/config";
import store from '@/store'
const baseURL = config.api.baseURL

export default () => ({
    login(data, params) {
        return axios.post(`${RESOURCE_NAME}/login`, data, {params, baseURL});
    },
    loginAs(data, params) {
        return axios.post(`${RESOURCE_NAME}/login-as`, data, {params, baseURL, headers: {
            'Authorization': store.getters.getHeaderAuthorization
        }});
    },
    check(params) {
        return axios.get(`${RESOURCE_NAME}/`, {params, baseURL, headers: {
            'Authorization': store.getters.getHeaderAuthorization
        }});
    },
    refreshTokens(params) {
        return axios.get(`${RESOURCE_NAME}/refresh-token`, {params, baseURL, headers: {
            'Authorization': store.getters.getRefreshHeaderAuthorization
        }});
    },
    logout(data, params) {
        return axios.post(`${RESOURCE_NAME}/logout`, data, {params, baseURL, headers: {
            'Authorization': store.getters.getHeaderAuthorization
        }});
    },
});